export default "__VITE_ASSET__C4qt8elo__"